import { Router } from '@angular/router';
import { TemplateRef } from '@angular/core';
import { Grid } from '../../../../shared/Models/grid';
import { BooleanColumn, TextColumn, Column } from '../../../../shared/Models/columns';
import { PartsService } from '../../../Services/parts.service';

export interface BasePartsGridOptions {
  router: Router;
  partsService: PartsService;
  partRowDetail: TemplateRef<any>;
  showButton?: boolean;
  inPopUp?: boolean;
  simpleSearch?: boolean;
  archive?: boolean;
  multipleRowSearch?: boolean;
  params?: any;
  method?: string;
  defaultSort?: string;
  defaultSortType?: 'asc' | 'desc';
  additionalColumns?: Column[];
  includeItemColumn?: boolean;
}

export function createBasePartsGridConfig(options: BasePartsGridOptions): Grid {
  const {
    router,
    partsService,
    partRowDetail,
    showButton = false,
    inPopUp = false,
    simpleSearch = false,
    archive = false,
    multipleRowSearch = true,
    params = undefined,
    method = 'getPart',
    defaultSort = 'id',
    defaultSortType = 'desc',
    additionalColumns = [],
    includeItemColumn = false
  } = options;

  const baseColumns: Column[] = [];

  // Add item column if needed (for modal)
  if (includeItemColumn) {
    baseColumns.push(<BooleanColumn>{
      name: 'doctrine.part.name',
      prop: 'item',
      type: BooleanColumn.type,
      translate: true,
      sortable: false,
    });
  }

  // Add standard part columns
  baseColumns.push(
    <TextColumn>{
      name: 'doctrine.part.name',
      prop: 'name',
      sortable: true,
      type: TextColumn.type,
      translate: true
    },
    <TextColumn>{
      name: 'doctrine.part.code',
      prop: 'code',
      sortable: true,
      type: TextColumn.type,
      translate: true,
      responsiveHideCallback: (width: number) => width < 1024
    },
    <TextColumn>{
      name: 'doctrine.part.stockAmount',
      prop: 'stockAmount',
      sortable: false,
      type: TextColumn.type,
      translate: true
    },
    <TextColumn>{
      name: 'doctrine.part.openOrdersAmount',
      prop: 'openOrdersAmount',
      sortable: false,
      type: TextColumn.type,
      translate: true
    },
    <TextColumn>{
      name: 'doctrine.part.freeStockAmount',
      prop: 'freeStockAmount',
      sortable: false,
      type: TextColumn.type,
      translate: true
    }
  );

  // Add any additional columns
  baseColumns.push(...additionalColumns);

  const gridConfig: Grid = {
    columns: baseColumns,
    service: partsService,
    rememberURL: router.url,
    method,
    defaultSort,
    rowDetailTemplate: partRowDetail,
    rowDetailShowCallback: (_, size: number) => size < 1400,
    defaultSortType,
    showButton,
    multipleRowSearch,
  };

  // Add optional properties
  if (inPopUp) {
    gridConfig.inPopUp = inPopUp;
  }
  if (simpleSearch) {
    gridConfig.simpleSearch = simpleSearch;
  }
  if (archive) {
    gridConfig.archive = archive;
  }
  if (params) {
    gridConfig.params = params;
  }

  return gridConfig;
} 